import { TransactionAdjustmentComponent } from "../../components";

export default function TransactionAdjustmentApprovalPage() {
  return <TransactionAdjustmentComponent.TransactionAdjustmentApprovalList />;
}
